import React, { useState, useEffect } from "react";
import axios from 'axios';
import PropTypes from 'prop-types';

//constants
import { urlAssets } from '../../Constants'; 

//components
import Loading from '../common/Loading';
import Player from '../player/Player';

const Winner = props => {

    console.log('Winner')
    const responseStatusOk = 200;
    const { slugCategory, slugWinner } = props;
    const urlJsonPlayer = `${urlAssets}/json/${slugCategory}/${slugWinner}.json`;
    const [dataPlayer, setDataPlayer] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getDataPlayer = async () => {
            const response = await axios(urlJsonPlayer);
            if(response.status === responseStatusOk){
                setDataPlayer(response.data);
                setLoading(false);
            }            
        }           

        getDataPlayer();                        
    },[]);

    return (
        loading 
        ? <Loading />
        : <Player dataPlayer={dataPlayer} />
    )
}

export default Winner;

Winner.proTypes = {
    slugCategory: PropTypes.string.isRequired,
    slugWinner: PropTypes.string.isRequired
}

